import React from 'react';
import styled from 'styled-components';
import linkedinicon from "../images/in.svg";
import xicon from "../images/x.svg";
import mailicon from "../images/mail.svg";
import Logo from '../logo.svg';
import { aboutData } from '../data';

const StyledFooter = styled.footer`
    background-color: ${props => props.theme.darkBg2};
    padding: 26px 7rem 38px;
    border-top: 1px solid rgb(225 128 247 / 9%);
    display: flex;
    justify-content: space-between;
    align-items: center;
        width: 100%;
    
    @media screen and (max-width: 767px) {
        padding: 1rem;
        flex-direction: column;
        gap: 30px;
    }
`;

const FooterLinks = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
`;

const FooterLogo = styled.div`
    display: flex;
    align-items: center;
`;

const MinLink = styled.a`
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    text-align: left;
    color: ${props => props.theme.textColor};
`;

export default function Footer() {
  return (
    <StyledFooter>
        <FooterLinks>
            <MinLink href={aboutData.linkedin}><img src={linkedinicon} alt={"in"} width={"30px"} height={"30px"} /></MinLink>
            <MinLink href={aboutData.x}><img src={xicon} alt={"x"} width={"30px"} height={"30px"} /></MinLink>
            <MinLink href={`mailto:${aboutData.mail}`}><img src={mailicon} alt={"mail"} width={"30px"} height={"30px"} /></MinLink>
        </FooterLinks>
        <FooterLogo>
        <img src={Logo} alt="Bubble Logo" width="51px" height="52px" />
        </FooterLogo>
        <div style={{display: "none", justifyContent: "space-around", alignItems: "center", margin: "30px 0"}}>
              <MinLink>Terms and services</MinLink>
              <MinLink>Legal agreement</MinLink>
        </div>
    </StyledFooter>
  );
};
